/**
 * Shared manager bonus formula
 * ((bonus - incremental_bonus - charge) / 2) + (incremental_bonus * rate / 100)
 * For historical periods where incremental_bonus = 0, simplifies to (bonus - charge) / 2
 *
 * @param {number} bonus - Total bonus from creator_monthly
 * @param {number} charge - Charge from creator_monthly
 * @param {number} incremental_bonus - Incremental bonus from creator_monthly
 * @param {number} incremental_rate - Manager's incremental rate (default 50)
 * @returns {number}
 */
export const calculateManagerBonus = (bonus, charge, incremental_bonus, incremental_rate) => {
  const b = bonus ?? 0;
  const c = charge ?? 0;
  const ib = incremental_bonus ?? 0;
  const rate = incremental_rate ?? 50;
  return ((b - ib - c) / 2) + (ib * rate / 100);
};
